import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormInput } from "@/utils";
import { Loading, Toast } from "@/components";
import { useTokenExchangeMutation } from "@/redux/tokenApi";
import logoImg from "@/assets/icons/icon-mobilicar-logo_bk.png";

export const Login = () => {
    const navigate = useNavigate();
    const { formData, handleChange, setFormData } = useFormInput({
        toastMsg: "",
        loginId: "",
        password: "",
        loginType: "",
    });
    const { toastMsg, loginId, password } = formData;

    const [tokenExchange, { isLoading, isError }] = useTokenExchangeMutation();

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        if (token) {
            navigate("/");
        }
    }, [navigate]);

    const handleLogin = async () => {
        try {
            const loginBody = {
                loginId: loginId,
                password: password,
                accountType: "ID",
            };

            const response = await tokenExchange(loginBody).unwrap(); // unwrap(): API 호출 결과 실패시 catch(err)

            if (response && response.access_token) {
                localStorage.setItem("access_token", response.access_token);
                localStorage.setItem("loginId", loginId);
                navigate("/");
            } else {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "로그인 실패",
                }));
            }
        } catch (err) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: err.message || "로그인 실패",
            }));
        }
    };

    const handleEnter = (e) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    const handleFindAuth = () => {
        navigate("/auth/find");
    };

    const handleSignup = () => {
        navigate("/auth/signup");
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="login">
                <div className="login-container">
                    <div className="login-banner">
                        <span>
                            <img src={logoImg} alt="Logo" />
                        </span>
                        <span>MOBILICAR PARTNERS</span>
                    </div>
                    <div className="login-form">
                        <div className="form-title">
                            모빌리카와 새로운
                            <br />
                            비즈니스를 함께 합니다.
                        </div>
                        <div className="form-content">
                            <input
                                type="text"
                                placeholder="ID를 입력하세요"
                                name="loginId"
                                value={formData?.loginId || ""}
                                onChange={handleChange}
                                onKeyDown={handleEnter}
                            />
                            <input
                                type="password"
                                placeholder="비밀번호를 입력하세요"
                                name="password"
                                value={formData?.password || ""}
                                onChange={handleChange}
                                onKeyDown={handleEnter}
                            />
                            <button type="button" className="btn-login" onClick={handleLogin}>
                                로그인
                            </button>
                            <div className="login-option">
                                <button type="button" onClick={handleFindAuth}>
                                    아이디 / 비밀번호 찾기
                                </button>
                                <button type="button" onClick={handleSignup}>
                                    회원가입
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
